@if (hasRewardItems) {
<div class="_rewardBanner flex flex-middle flex-justify-center">
    <i class="icon-gift-2 inline-flex _giftIcon"></i>
    <span class="p3">
        <span *iCms="'message' of content"></span>
    </span>
</div>
}
